// extracted by mini-css-extract-plugin
export default {"w-full":"Earning_w-full__6pgvn","row":"Earning_row__jid6H","col":"Earning_col__XI3Ls","card":"Earning_card__r4ZZe"};